import { render, staticRenderFns } from "./AirThingsSetting.vue?vue&type=template&id=0e64fb8a&scoped=true"
import script from "./AirThingsSetting.vue?vue&type=script&lang=js"
export * from "./AirThingsSetting.vue?vue&type=script&lang=js"
import style0 from "./AirThingsSetting.vue?vue&type=style&index=0&id=0e64fb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e64fb8a",
  null
  
)

export default component.exports